import React from 'react'
import PropTypes from 'prop-types'

const Note = ({ value, onChange, containerClassName, inputClassName }) => {
    return (
        <div className={containerClassName}>
            <h6>Special request</h6>
            <textarea
                className={inputClassName}
                placeholder="Please note that special request is on best effort basis. We cannot guarantee that your special request can be met."
                style={{
                    resize: 'none',
                    backgroundColor: 'hsl(0, 0%, 100%)',
                    border: '2px solid hsl(0, 0%, 80%)',
                    borderRadius: '4px',
                    boxSizing: 'border-box',
                    width: '100%',
                    height: '130px',
                }}
                value={value}
                onChange={e => onChange(e.target.value)}
            />
        </div>
    )
}

Note.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    containerClassName: PropTypes.string,
    inputClassName: PropTypes.string,
}

export default Note
